import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'al2014',
    ecrans: ['00-2']
});
